export default "__VITE_ASSET__g5DI6aa7__"